<template>
  <div class="flex items-center justify-center h-screen">
    <div class="bg-white text-black rounded-lg shadow-lg p-4 m-4">
      <div class="grid grid-cols-1 md:grid-cols-2 overflow-y-auto">
        <div class="flex justify-end">
          <pre class="overflow-y-auto h-64 pr-4">
      HARVEY
You know what?
I have had it up to here
with you blaming me
for every hard choice
that comes with this job.

      MIKE
- Harvey, come on.

      HARVEY
- Shut up!

      HARVEY
Is your life better or worse
than before I hired you?

      MIKE
It's both.

      HARVEY
Well, maybe you should focus
on the better,
because the next time
I have the option
to cross a line
to save you,
I'll send you packing
and not think twice.

      HARVEY
Now get your shit together.
          </pre>
        </div>
        <div class="flex justify-left flex-col">
          <pre class="pl-0 md:pl-4 flex-grow mt-4">
      YOU
And I need
to get my shit together.
          </pre>
          <button @click="login" class="bg-gray-100 hover:bg-gray-300 text-gray-800 border border-gray-4 font-bold py-2 px-4 rounded inline-flex items-center shadow-lg">
            <svg class="fill-current w-4 h-4 mr-2" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48"><g><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path><path fill="none" d="M0 0h48v48H0z"></path></g></svg>
            <span>Sign in with Google</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fb from '../firebaseConfig'

export default {
  created () {
    if (this.$store.getters.hasUser) {
      this.$router.push('/collect')
    }
  },
  methods: {
    login () {
      const provider = new fb.auth.GoogleAuthProvider()
      fb.auth().signInWithPopup(provider).then(result => {
        const user = JSON.parse(JSON.stringify(result.user))
        this.$store.commit('setUser', user)
        this.$router.push('/collect')
      })
    }
  }
}
</script>
